module.exports = __webpack_public_path__ + "img/12.cc06f661.jpg";